import { useContext } from 'react';

import cartContext from 'contexts/cartContext';

function useCart() {
  return useContext(cartContext);
}

export default useCart;
